import {
    RESET_MESSAGE,
    GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_SUCCESS,
    GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_FAILURE,
    GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS,
    GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_SUCCESS,
    GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_FAILURE,
    GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS,
    GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_SUCCESS,
    GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_FAILURE,
    GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS,

} from '../types/actionTypes';

const initialState = {
    totalReceivablePayableDashboard: [],
    MonthAndCustomerWiseSalesDashboard: [],
    MonthAndCustomerWisePurchaseDashboard: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const dashboard_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_SUCCESS:
            return { ...state, totalReceivablePayableDashboard: action.totalReceivablePayableDashboard, loading: false };
        case GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS:
            return { ...state, loading: true, error: false };

        case GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_SUCCESS:
            return { ...state, MonthAndCustomerWiseSalesDashboard: action.MonthAndCustomerWiseSalesDashboard, loading: false };
        case GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS:
            return { ...state, loading: true, error: false };

        case GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_SUCCESS:
            return { ...state, MonthAndCustomerWisePurchaseDashboard: action.MonthAndCustomerWisePurchaseDashboard, loading: false };
        case GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default dashboard_reducer;